export default [
	{ libelle: "Appartement", slug: "appartement" },
	{ libelle: "Maison", slug: "maison" },
	{ libelle: "Immeuble", slug: "immeuble" },
	{ libelle: "Parking", slug: "parking" },
	{ libelle: "Terrain", slug: "terrain" },
	{ libelle: "Professionnel", slug: "professionnel" },
];
